export interface checkExternalIdExistsPayload {
    externalId: string
}
export interface checkExternalIdExistsOrNot {
    data: {
        isSameOrgEntity: boolean,
        isExternalIdAlreadyPresent: boolean,
        newOrgEntityId: string,
        isNew: boolean
    },
    isActionSuccess: boolean
}

export interface createNewPatient {
    data: {
        type: string,
        isIndividual: boolean,
        displayName: string,
        orgEntityId?: string,
        externalId: string,
        firstName: string,
        lastName: string,
        dateOfBirth: string,
        gender: string,
        cellPhone: string,
        homePhone: string,
        email: string,
        address: Address,
        healthPlan?: string,
        memberId?: string,
        language?: string,
        leadSource?: string,
        callSource?: string
    },
    isAlreadyPresent: boolean
}

    export interface Address {
        addressLine1: string,
        addressLine2: string,
        city: string,
        postalCode: string,
        stateOrProvinceCode: string,
        timezone?: string
    }

export const months = [
    {
        id: '01',
        displayName: 'January',
        maxDays: 31,
    },
    {
        id: '02',
        displayName: 'February',
        maxDays: 29,
    },
    {
        id: '03',
        displayName: 'March',
        maxDays: 31,
    },
    {
        id: '04',
        displayName: 'April',
        maxDays: 30,
    },
    {
        id: '05',
        displayName: 'May',
        maxDays: 31,
    },
    {
        id: '06',
        displayName: 'June',
        maxDays: 30,
    },
    {
        id: '07',
        displayName: 'July',
        maxDays: 31,
    },
    {
        id: '08',
        displayName: 'August',
        maxDays: 31,
    },
    {
        id: '09',
        displayName: 'September',
        maxDays: 30,
    },
    {
        id: '10',
        displayName: 'October',
        maxDays: 31,
    },
    {
        id: '11',
        displayName: 'November',
        maxDays: 30,
    },
    {
        id: '12',
        displayName: 'December',
        maxDays: 31,
    },
]

export function isLeapYear(year: number): boolean {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0
}

// Year is optional: when it is not a full 4-digit year, February is allowed 29 days.
export function getMaxDaysInMonth(month: any, year?: any): number {
    const monthId = String(month ?? '').padStart(2, '0')
    const maxDays = months.find((m) => m.id === monthId)?.maxDays ?? 0
    if (monthId === '02' && /^\d{4}$/.test(String(year ?? ''))) {
        return isLeapYear(Number(year)) ? 29 : 28
    }
    return maxDays
}

export function isValidCalendarDate(month: any, day: any, year: any): boolean {
    if (!/^\d{4}$/.test(String(year ?? ''))) {
        return false
    }
    const dayNumber = Number(day)
    return dayNumber >= 1 && dayNumber <= getMaxDaysInMonth(month, year)
}

export interface patientInfo {
    isIndividual: boolean
    type: string
    externalId: string
    displayName: string
    firstName: string
    middleName?: string
    lastName: string
    dateOfBirth: string
    gender: string
    homePhone: string
    cellPhone: string
    email: string
    address?: addressObject
    healthPlan?: string
    memberId?: string
    language?: string
    leadSource?: string
    callSource?: string 
}
export interface patientInformationObject {
    patientInfo: patientInfo
}

export interface addressObject {
    addressLine1: string
    addressLine2: string
    city: string
    postalCode: string
    stateOrProvinceCode: string
    timezone?: string
}
export interface DateOfBirthObject {
    dateOfBirth: string
    dobMonth: number | null
    dobYear: string
    dobDay: number | null
}

export const leadSourceArray = ["Self-Referral", "Friend/Family", "Case Manager", "Physician", "Health Plan"];
export const callSourceArray = ["Phone", "Website"];
export const salutationArray = ["Mr.", "Ms.", "Mrs.", "Dr.", "Prof."];
export const genderArray = ["Male", "Female", "Other"];
export const relationshipArray = ["Spouse / Significant Other", "Parent", "Child", "Sibling", "Nurse/Case Worker/Social Worker", "Friend", "Other"];
export const preferredApptReminderMethodArray = ["SMS", "Email"];
export const carrierTypeArray = ["Primary", "Secondary"];
export const medicarePrescriptionPaymentPlanArray = ["Yes", "No", "Not Sure"];
export const digitalConsentArray = ["Yes", "No"];